import { createFileRoute, redirect } from '@tanstack/react-router';

/** Bare /admin opens the shared role-aware dashboard. */
export const Route = createFileRoute('/_authed/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});
